import React, { useContext, useEffect, useReducer, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import api, { ADMIN_URL } from '../api';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Button, Col, Container, NavDropdown, Row } from 'react-bootstrap';
import Product from '../components/Product';
import { Helmet } from 'react-helmet-async';
import { getError } from '../Util';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MeaasgeBox';
import CardHeader from '../components/CardHeadder';
import { Store } from '../Store';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        products: action.payload.products,
        page: action.payload.page,
        pages: action.payload.pages,
        countProducts: action.payload.countProducts,
        loading: false,
      };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};



export default function SearchScreen() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const category = sp.get('category') || 'all';
  const query = sp.get('query') || 'all';
  const size = sp.get('size') || 'all';
  const color = sp.get('color') || 'all';
  const fabric = sp.get('fabric') || 'all';
  const order = sp.get('order') || 'newest';
  const page = sp.get('page') || 1;

  const [{ loading, error, products = [], pages, countProducts }, dispatch] =
    useReducer(reducer, {
      loading: true,
      error: '',
    });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get(
          `/api/products/search?page=${page}&query=${query}&category=${category}&size=${size}&color=${color}&fabric=${fabric}&order=${order}`
        );
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      } catch (err) {
        dispatch({
          type: 'FETCH_FAIL',
          payload: getError(err),
        });
      }
    };
    fetchData();
  }, [category, order, page, query, size, color, fabric, navigate]);

  const [categories, setCategories] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);
  const [fabrics, setFabrics] = useState([]);
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    navigate('/signin');
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const { data } = await api.get(`/api/products/filters`);

        setCategories(data.categories);
        setSizes(data.sizes);
        setColors(data.colors);
        setFabrics(data.fabrics);
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchFilters();
  }, []);

  const getFilterUrl = (filter) => {
    const filterPage = filter.page || page;
    const filterCategory = filter.category || category;
    const filterQuery = filter.query || query;
    const filterSize = filter.size || size;
    const filterColor = filter.color || color;
    const filterFabric = filter.fabric || fabric;
    const sortOrder = filter.order || order;
    return `/products?category=${filterCategory}&query=${filterQuery}&size=${filterSize}&color=${filterColor}&fabric=${filterFabric}&order=${sortOrder}&page=${filterPage}`;
  };

  return (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-3 py-1">
        <div className="marginAll">
          <Helmet>
            <title>Products</title>
          </Helmet>

          <div>
            <Row className="align-items-center d-flex justify-content-between flex-wrap mb-3 mt-2 py-3">
              <Col xs="auto">
                <h1 style={{ fontSize: '2rem', marginBottom: 0 }}>
                  Feature Products
                </h1>
              </Col>

              <Col xs="auto">
                <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                  {userInfo ? (
                    <NavDropdown
                      title={
                        <span
                          style={{ backgroundColor: '#801001' }}
                          className="px-3 py-2 text-white rounded-pill shadow-sm"
                        >
                          {userInfo.name}
                        </span>
                      }
                      id="collasible-nav-dropdown"
                    >
                      <NavDropdown.Item as={Link} to="/profile">
                        <span className="text-gray">User Profile</span>
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <Link
                        className="dropdown-item"
                        to="#signout"
                        onClick={signoutHandler}
                      >
                        <span className="text-gray">Signout</span>
                      </Link>
                    </NavDropdown>
                  ) : (
                    <a
                      href={ADMIN_URL}
                      className="nav-link text-white px-3 py-2 rounded-pill shadow-sm"
                      style={{ backgroundColor: '#801001' }}
                    >
                      Signin
                    </a>
                  )}

                  {userInfo && userInfo.isAdmin && (
                    <NavDropdown
                      title={
                        <span
                          style={{ backgroundColor: '#801001' }}
                          className="px-3 py-2 text-white rounded-pill shadow-sm"
                        >
                          Admin
                        </span>
                      }
                      id="admin-nav-dropdown"
                    >
                      <NavDropdown.Item as={Link} to="/admin/products">
                        <span className="text-gray">Products</span>
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/admin/orders">
                        <span className="text-gray">Orders</span>
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/admin/fabrics">
                        <span className="text-gray">Fabrics</span>
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}
                </div>
              </Col>
            </Row>
          </div>

          {/* Category Filter at the Top */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex flex-wrap gap-2 justify-content-center">
                <Button
                  variant="outline-secondary"
                  style={{
                    borderColor: category === 'all' ? '#801001' : '#801001',
                    color: category === 'all' ? 'white' : '#801001',
                    backgroundColor:
                      category === 'all' ? '#801001' : 'transparent',
                    minWidth: '100px', // Ensure buttons have a minimum width
                  }}
                  onClick={() => navigate('/products')}
                >
                  All
                </Button>
                {categories.map((c) => (
                  <Button
                    key={c.name}
                    variant="outline-secondary"
                    style={{
                      borderColor: c.name === category ? '#801001' : '#801001',
                      color: c.name === category ? 'white' : '#801001',
                      backgroundColor:
                        c.name === category ? '#801001' : 'transparent',
                      minWidth: '100px',
                    }}
                    onClick={() => navigate(getFilterUrl({ category: c.name }))}
                  >
                    {c.name}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>

          <Row>
            {/* Mobile Filter Toggle Button */}
            <Col xs={12} className="d-md-none mb-3">
              <Button
                onClick={() => setShowMobileFilters(!showMobileFilters)}
                style={{
                  backgroundColor: '#801001',
                  border: 'none',
                  width: '100%',
                  padding: '10px',
                  fontWeight: '600'
                }}
              >
                <i className={`fas fa-${showMobileFilters ? 'times' : 'filter'} me-2`}></i>
                {showMobileFilters ? 'Hide Filters' : 'Show Filters'}
              </Button>
            </Col>
            
            <Col
              xs={12}
              md={3}
              className={`pe-md-2 ${showMobileFilters ? 'd-block' : 'd-none d-md-block'}`}
            >
              {[
                { title: 'Size', options: sizes, state: size, key: 'size' },
                { title: 'Color', options: colors, state: color, key: 'color' },
                {
                  title: 'Fabric',
                  options: fabrics,
                  state: fabric,
                  key: 'fabric',
                },
              ].map((filter) => (
                <div
                  key={filter.key}
                  className="searchCard mb-3 p-3"
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    boxShadow: '0 6px 15px rgba(0,0,0,0.08)',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    minWidth: '0',
                    overflow: 'hidden',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow =
                      '0 10px 25px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow =
                      '0 6px 15px rgba(0,0,0,0.08)';
                  }}
                >
                  <h4
                    style={{
                      fontSize: 'clamp(0.9rem, 2.5vw, 1.2rem)',
                      marginBottom: '0.75rem',
                      fontWeight: '600',
                      color: '#801001',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {filter.title}
                  </h4>
                  <div
                    className="d-flex flex-wrap gap-2"
                    style={{ paddingLeft: '0', minWidth: '0' }}
                  >
                    <Link
                      to={getFilterUrl({ [filter.key]: 'all' })}
                      style={{
                        display: 'inline-block',
                        textDecoration: 'none',
                        color: filter.state === 'all' ? '#fff' : '#801001',
                        backgroundColor: filter.state === 'all' ? '#801001' : '#f8f9fa',
                        fontWeight: filter.state === 'all' ? '600' : '400',
                        fontSize: '0.8rem',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        border: '1px solid #801001',
                        transition: 'all 0.3s',
                      }}
                    >
                      All
                    </Link>
                    {filter.options.map((opt) => (
                      <Link
                        key={opt}
                        to={getFilterUrl({ [filter.key]: opt })}
                        style={{
                          display: 'inline-block',
                          textDecoration: 'none',
                          color: opt === filter.state ? '#fff' : '#801001',
                          backgroundColor: opt === filter.state ? '#801001' : '#f8f9fa',
                          fontWeight: opt === filter.state ? '600' : '400',
                          fontSize: '0.8rem',
                          padding: '6px 14px',
                          borderRadius: '20px',
                          border: '1px solid #801001',
                          transition: 'all 0.3s',
                        }}
                      >
                        {opt}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </Col>

            <Col
              xs={12}
              md={9}
            >
              {loading ? (
                <LoadingBox />
              ) : error ? (
                <MessageBox variant="danger">{error}</MessageBox>
              ) : (
                <>
                  <Row className="justify-content-between mb-3 mt-2">
                    <Col md={6}>
                      <div style={{ color: '#801001', fontWeight: '600' }}>
                        {countProducts === 0 ? 'No' : countProducts} Results
                        {query !== 'all' && ' : ' + query}
                        {category !== 'all' && ' : ' + category}
                        {size !== 'all' && ' : Size ' + size}
                        {color !== 'all' && ' : Color ' + color}
                        {fabric !== 'all' && ' : Fabric ' + fabric}
                        {(query !== 'all' ||
                          category !== 'all' ||
                          size !== 'all' ||
                          color !== 'all' ||
                          fabric !== 'all') && (
                            <Button
                              className="closebtn"
                              variant="light"
                              onClick={() => navigate('/products')}
                              style={{
                                display: 'inline-flex', // keeps it in the same line
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#fff',
                                border: '2px solid #801001',
                                borderRadius: '50%',
                                padding: '0.3rem',
                                color: '#801001',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                transition: 'all 0.3s ease',
                                marginLeft: '0.5rem', // optional spacing
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#801001';
                                e.currentTarget.style.color = '#fff';
                                e.currentTarget.style.transform = 'scale(1.1)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#fff';
                                e.currentTarget.style.color = '#801001';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              <i className="fas fa-times-circle"></i>
                            </Button>
                          )}
                      </div>
                    </Col>

                    <Col
                      md={6}
                      className="text-end mt-2"
                      style={{ color: '#801001' }}
                    >
                      Sort by{' '}
                      <select
                        value={order}
                        onChange={(e) => {
                          navigate(getFilterUrl({ order: e.target.value }));
                        }}
                        style={{
                          padding: '5px 10px',
                          borderRadius: '8px',
                          border: '1px solid #801001',
                          color: '#801001',
                          fontWeight: '600'
                        }}
                      >
                        <option value="newest">Newest Arrivals</option>
                        <option value="oldest">Oldest Arrivals</option>
                      </select>
                    </Col>
                  </Row>

                  {products.length === 0 && (
                    <MessageBox>No Product Found</MessageBox>
                  )}

                  <Row>
                    {products.map((product) => (
                      <Col sm={6} lg={4} className="mb-3" key={product._id}>
                        <Product product={product} />
                      </Col>
                    ))}
                  </Row>

                  <div className="d-flex justify-content-center mt-5">
                    {[...Array(pages).keys()].map((x) => (
                      <Link
                        key={x + 1}
                        className="mx-1"
                        to={{
                          pathname: '/products',
                          search: getFilterUrl({ page: x + 1 }).substring(7),
                        }}
                      >
                        <Button
                          variant="light"
                          style={{
                            color: Number(page) === x + 1 ? '#801001' : '#000', // red for current page
                            fontWeight: Number(page) === x + 1 ? '600' : '400', // bold for current page
                          }}
                        >
                          {x + 1}
                        </Button>
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}
